module.exports = __webpack_public_path__ + "static/media/investment.ea35f0db.svg";